import { render, staticRenderFns } from "./ResponseTemplatesList.vue?vue&type=template&id=51f595e4&"
import script from "./ResponseTemplatesList.vue?vue&type=script&lang=js&"
export * from "./ResponseTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports